var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-editable":"","data-type":_vm.type,"data-name":_vm.block_name,"data-pageid":_vm.page_id,"data-block":_vm.getBlock(_vm.block_name).id},domProps:{"innerHTML":_vm._s(_vm.getBlock(_vm.block_name).content)}})}
var staticRenderFns = []

export { render, staticRenderFns }